module.exports = __webpack_public_path__ + "static/media/lovaclogo.14c7dc9f.png";